export const VOLUNTEER_ADMIN_DASHBOARD_SUCCESS = 'VOLUNTEER_ADMIN_DASHBOARD_SUCCESS';
export const VOLUNTEER_ADMIN_DASHBOARD_FAILURE = 'VOLUNTEER_ADMIN_DASHBOARD_FAILURE';

